import { Award, BadgeCheck, CircleDollarSign, Clock, ContactRound, DollarSign, Gamepad2, Heart, ImagesIcon, MessageCircleQuestionMark, PersonStanding, ScrollText, Settings, ShieldCheck, ShieldClose, Sparkles, Star, UserMinus } from "lucide-react";
import "./style.css"
import { navigateNav } from "../../utils/nav";
import { useNavigate } from "react-router-dom";
import { ChevronRight, HelpCircle } from "react-feather";
import { CRONOS_URL, LOURI_URL, PACOCA_URL, REFLEXO_URL, VERSONA_URL } from "../../utils/vars";
import { Icon } from "../icon";
import { useTheme } from "../../contexts/theme-context";
import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from "react";
import { redirectToLink } from "../../utils/text";
import { System } from "../../types";
import AdsterraAdSlot from "../../../../components/adsterra-ads/adsterra-ad-slot";
import {
    getThirdPartySponsoredSlotCount,
    SPONSORED_INTERNAL_ROTATION_MS,
} from "../../../../utils/adsterra-ads";

interface PropsLeft{
    children?: any
    hasDefault?: boolean
    moreLeft?: boolean
}
interface PropsRight{
    children?: any
    hasDefault?: boolean
    hasLink?: boolean
    moreRight?: boolean
    currentApp?: System
}
export function LeftContent({ children, hasDefault=true, moreLeft }: PropsLeft){
    const navigate = useNavigate();
    const { isDarkMode } = useTheme();
    const { t } = useTranslation();

    return (
        <div className={`user-select-none container-left-content ${moreLeft ? "container-left-content-more-left" : "" } scroll-none`}>
            {hasDefault ? (
                <div className="card-left" style={{ borderRadius:"50%" }}>
                    <h5>{t("settings.title")}</h5>
                    <div className="notification_opened row-notification open-notification row-user">
                        <span onClick={(e) => redirectToLink(`${PACOCA_URL}/configuracoes`, navigate)} className="name-likes" style={{ paddingLeft: 0 }}>
                            <Icon className="menu-father-icon" invertColor={!isDarkMode} alt="Ir para home" name="settings">
                                <Settings className="icon-settings" data-feather="settings" />
                            </Icon>
                            {t("settings.title")}
                        </span>
                    </div>
                    <div className="notification_opened row-notification open-notification row-user">
                        <span onClick={(e) => redirectToLink(`${PACOCA_URL}/privacidade`, navigate)} className="name-likes" style={{ paddingLeft: 0 }}>
                            <Icon className="menu-father-icon" invertColor={!isDarkMode} name="encrypted">
                                <ShieldCheck className="icon-settings" /> 
                            </Icon> {t("settings.privacy.title")}
                            {/* <UserMinus className="icon-settings"/> Privacidade */}
                        </span>
                    </div>
                    <div className="notification_opened row-notification open-notification row-user">
                        <span onClick={(e) => redirectToLink(`${PACOCA_URL}/acessibilidade`, navigate)} className="name-likes" style={{ paddingLeft: 0 }}>
                            <Icon className="menu-father-icon" invertColor={!isDarkMode} name="accessibility_new">
                                <PersonStanding className="icon-settings" /> 
                            </Icon> {t("settings.accessibility")}
                            {/* <PersonStanding className="icon-settings"/> Acessibilidade */}
                        </span>
                    </div>
                    <div className="notification_opened row-notification open-notification row-user">
                        <span onClick={(e) => redirectToLink(`${PACOCA_URL}/verificado`, navigate)} className="name-likes" style={{ paddingLeft: 0 }}>
                            <Icon className="menu-father-icon" invertColor={!isDarkMode} name="verified">
                                <BadgeCheck className="icon-settings" /> 
                            </Icon> {t("settings.verified")}
                           {/* <Star className="icon-settings"/> Verificado */}
                        </span>
                    </div>
                    <div className="notification_opened row-notification open-notification row-user">
                        <span onClick={(e) => redirectToLink(`${PACOCA_URL}/doacao`, navigate)} className="name-likes" style={{ paddingLeft: 0 }}>
                            <Icon className="menu-father-icon" invertColor={!isDarkMode} name="paid">
                                <CircleDollarSign className="icon-settings" /> 
                            </Icon> {t("settings.donate")}
                           {/* <DollarSign className="icon-settings"/> Doação */}
                        </span>
                    </div>
                    <div className="notification_opened row-notification open-notification row-user">
                        <span onClick={(e) => redirectToLink(`${PACOCA_URL}/suporte`, navigate)} className="name-likes" style={{ paddingLeft: 0 }}>
                            <Icon className="menu-father-icon" invertColor={!isDarkMode} name="contact_support">
                                <MessageCircleQuestionMark className="icon-settings" /> 
                            </Icon> {t("settings.support")}
                           {/* <HelpCircle className="icon-settings"/> Suporte */}
                        </span>
                    </div>
                    <div className="notification_opened row-notification open-notification row-user">
                        <span onClick={(e) => redirectToLink(`${PACOCA_URL}/significado-selos`, navigate)} className="name-likes" style={{ paddingLeft: 0 }}>
                            <Icon className="menu-father-icon" invertColor={!isDarkMode} name="editor_choice">
                                <Award className="icon-settings" />
                            </Icon> {t("settings.meaningSeals")}
                           {/* <Award className="icon-settings"/> Significado dos Selos */}
                        </span>
                    </div>
                    <div className="notification_opened row-notification open-notification row-user">
                        <span onClick={(e) => redirectToLink(`${PACOCA_URL}/jogos`, navigate)} className="name-likes" style={{ paddingLeft: 0 }}>
                            <Icon className="menu-father-icon" invertColor={!isDarkMode} name="sports_esports">
                                <Gamepad2 className="icon-settings" />
                            </Icon> {t("settings.games")}
                        </span>
                    </div>
                </div>
            ) : null}
            {children}
        </div>
    );
}
export function RightContent({children, hasDefault=true, hasLink=true, moreRight, currentApp=System.pacoca} : PropsRight){
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className={`user-select-none  container-right-content scroll-none ${moreRight ? "container-right-content-more-right" : "" }`}>
            <div className="content-right">
                {hasDefault ? (
                    <div className="card-left" style={{ borderRadius:"50%" }}>
                        <h5>{t("settings.apps")}</h5>
                                
                        {currentApp != System.pacoca && (
                            <div className="notification_opened row-notification open-notification row-user">
                                <span onClick={(e) => window.open(PACOCA_URL, '_blank')} className="name-likes" style={{ paddingLeft: 0 }}>
                                    <ContactRound style={{ height: '19px', marginRight: '3px' }}/>
                                    Paçoca
                                </span>
                            </div>
                        )}

                        {currentApp != System.reflexo && (
                            <div className="notification_opened row-notification open-notification row-user">
                                <span onClick={(e) => window.open(REFLEXO_URL, '_blank')} className="name-likes" style={{ paddingLeft: 0 }}>
                                    <ImagesIcon style={{ height: '19px', marginRight: '3px' }}/>
                                    Reflexo
                                </span>
                            </div>
                        )}

                        {currentApp != System.versona && (
                            <div className="notification_opened row-notification open-notification row-user">
                                <span onClick={(e) => window.open(VERSONA_URL, '_blank')} className="name-likes" style={{ paddingLeft: 0 }}>
                                    <ScrollText style={{ height: '19px', marginRight: '3px' }}/>
                                    Versona
                                </span>
                            </div>
                        )}

                        {/* {currentApp != System.cronos && (
                            <div className="notification_opened row-notification open-notification row-user">
                                <span onClick={(e) => window.open(CRONOS_URL, '_blank')} className="name-likes" style={{ paddingLeft: 0 }}>
                                    <Clock style={{ height: '19px', marginRight: '3px' }}/>
                                    Cronos
                                </span>
                            </div>
                        )} */}

                        <div className="notification_opened row-notification open-notification row-user">
                            <span onClick={(e) => navigate(`${PACOCA_URL}/jogos`)} className="name-likes" style={{ paddingLeft: 0 }}>
                                <Gamepad2 style={{ height: '19px', marginRight: '3px' }}/>
                                Paçoca Games
                            </span>
                        </div>

                        {currentApp != System.louri && (
                            <div className="notification_opened row-notification open-notification row-user">
                                <span onClick={() => window.open(LOURI_URL, '_blank')} className="name-likes" style={{ paddingLeft: 0 }}>
                                    <Sparkles style={{ height: '19px', marginRight: '3px' }}/>
                                    Louri
                                </span>
                            </div>
                        )}
                    </div> 
                ) : null}
            </div>

            {children}

            {hasLink ? (
                <div style={{ paddingLeft: 10, paddingRight: 10, display: "flex", gap: 20, marginTop: -5}}>
                   <div>
                        <span style={{ color: "var(--secondary-blue)", marginRight: 5 }}>•</span>
                        <span onClick={(e) => redirectToLink(`${PACOCA_URL}/sobre`, navigate)} style={{ color: "var(--secondary-blue)", cursor: "pointer", fontSize: 15, fontWeight: 700 }}>
                            {t("settings.about")}
                        </span>
                   </div>

                    <div>
                        <span style={{ color: "var(--secondary-blue)", marginRight: 5 }}>•</span>
                        <span onClick={(e) => redirectToLink(`${PACOCA_URL}/termos-uso`, navigate)} style={{ color: "var(--secondary-blue)", cursor: "pointer", fontSize: 15, fontWeight: 700 }}>
                            {t("settings.termsUse")}
                        </span>
                    </div>
                    
                    <div>
                        <span style={{ color: "var(--secondary-blue)", marginRight: 5 }}>•</span>
                        <span onClick={(e) => redirectToLink(`${PACOCA_URL}/diretrizes`, navigate)} style={{ color: "var(--secondary-blue)", cursor: "pointer", fontSize: 15, fontWeight: 700 }}>
                            {t("settings.guidelines")}
                        </span>
                    </div>
                </div>
            ) : null}
        </div>
    );
}

export const SponsoredContainer = ({ children } : { children: any } ) =>{
    return (
        <div className={`user-select-none container-right-content container-right-sponsored scroll-none`}>
            {children}
        </div>
    )
}

export const Sponsored = ({ src, title, link } : { src: string, title: string, link: string } ) =>{

    return (
        <div className="sponsored">
            <div className="col-one">
                <img src={src} alt=""/>
            </div>
            <div className="col col-text-sponsored">
                <p className="titlei-sponsored">{title}</p>
                <a href={link} target="_blank" className="link-sponsored">{link.replace(/^https?:\/\//, '').split('/')[0]}</a>
            </div>
        </div>
    )
}
let ITEMS_PER_PAGE = window.innerWidth <= 1450 ? 1 : 3;
if(window.innerHeight <= 852){
    ITEMS_PER_PAGE = 2
}
if(window.innerHeight <= 720){
    ITEMS_PER_PAGE = 1
}

// Um Banner 300x250 precisa de cerca de 276px com a identificação de
// publicidade. Em telas menores, dois banners ficariam abaixo da dobra.
const MAX_SIDEBAR_ADSTERRA_SLOTS = window.innerHeight >= 1200 ? 2 : 1;

export const SponsoredContent = ({ currentApp = System.pacoca }: { currentApp?: System }) => {
    const { t } = useTranslation();
    const sponsoredList = [
        {
            src: `${PACOCA_URL}/img/link-preview.png`,
            title: t("ads.ads"),
            link: `${PACOCA_URL}/anuncios`
        },
        // {
        //     src: `${PACOCA_URL}/img/sponsored/image1.png`,
        //     title: "WIBX - conectamos marcas e pessoas com recompensas",
        //     link: "https://wibx.io/"
        // },
        // {
        //     src: `${PACOCA_URL}/img/sponsored/image2.png`,
        //     title: "Programa de fidelidade que gera valor para sua Marca",
        //     link: "https://boraclub.app"
        // },
        // {
        //     src: `${PACOCA_URL}/img/sponsored/image3.png`,
        //     title: "Faça o seu cadastro pelo link",
        //     link: "https://uaucaixa.com.br/ola"
        // },
    ];

    if (currentApp != System.pacoca) {
        sponsoredList.push({
            src: "https://play-lh.googleusercontent.com/KcG5SKGHIoBaUtc8BhXOob1ikTdNNK5vyeGpEWGVot0nQhwtJWAuBFM7x9qsL4kIhRXtPEqe7IhlAiU0x-cr8A=w416-h235-rw",
            title: t("ads.pacoca"),
            link: PACOCA_URL
        });
    }

    if (currentApp != System.reflexo) {
        sponsoredList.push({
            src: "https://pacoca.net/img/sponsored/reflexo.png",
            title: t("ads.reflexo"),
            link: REFLEXO_URL
        });
    }

    if (currentApp != System.versona) {
        sponsoredList.push({
            src: "https://play-lh.googleusercontent.com/IVSpy05DQyLeOhr35YdJBnfFdonUWC5iUcLMgh4osMQQoh7Zu73cfFMWfSXI55DF0ZAcxyBffa_OeHUYru5Q=w416-h235-rw",
            title: t("ads.versona"),
            link: VERSONA_URL
        });
    }

    const shuffleArray = <T,>(array: T[]) => {
        return [...array].sort(() => Math.random() - 0.5);
    };

    // Mantém somente uma divulgação do ecossistema Paçoca e reserva os
    // demais espaços disponíveis no desktop para a rede de anúncios.
    const sponsoredListRef = useRef(sponsoredList);
    sponsoredListRef.current = sponsoredList;
    const [visibleItems, setVisibleItems] = useState(() =>
        shuffleArray(sponsoredList).slice(0, 1),
    );
    const [unavailableAdSlots, setUnavailableAdSlots] = useState<Set<number>>(
        () => new Set(),
    );
    const thirdPartySponsoredSlotCount = Math.min(
        getThirdPartySponsoredSlotCount(ITEMS_PER_PAGE, visibleItems.length),
        MAX_SIDEBAR_ADSTERRA_SLOTS,
    );

    useEffect(() => {
        const rotation = window.setInterval(() => {
            setVisibleItems(current => {
                const currentLink = current[0]?.link;
                const candidates = sponsoredListRef.current.filter(
                    item => item.link !== currentLink,
                );
                const nextItems = candidates.length
                    ? candidates
                    : sponsoredListRef.current;

                return shuffleArray(nextItems).slice(0, 1);
            });
        }, SPONSORED_INTERNAL_ROTATION_MS);

        return () => window.clearInterval(rotation);
    }, []);

  return (
    <div className="sponsored-container">
      <h5 className="title-content">{t("settings.sponsored")}</h5>

      <div className="sponsored-grid">
        {visibleItems.map(item => (
          <Sponsored
            key={item.link}
            src={item.src}
            title={item.title}
            link={item.link}
          />
        ))}

        {Array.from({ length: thirdPartySponsoredSlotCount }, (_, index) =>
          unavailableAdSlots.has(index) ? null : (
            <AdsterraAdSlot
              key={`adsterra-sponsored-${index}`}
              className="sponsored-adsterra"
              onError={() => {
                setUnavailableAdSlots(current => {
                  if (current.has(index)) return current;
                  const next = new Set(current);
                  next.add(index);
                  return next;
                });
              }}
            />
          ),
        )}
      </div>
    </div>
  );
};